module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-guide-ios"
  }, [_c('h2', {
    staticClass: "download-guide-ios-title"
  }, [_vm._v("PlexVPN iOS版下载教程")]), _vm._v(" "), _c('div', {
    staticClass: "download-guide-ios-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "dgic-item"
  }, [_c('img', {
    staticClass: "dgic-item-img",
    attrs: {
      "src": require("../../../static/img/downloadGuideIos/dgi_img_search.jpg"),
      "alt": "dgi-img-search"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dgic-item-content"
  }, [_c('h3', {
    staticClass: "dgic-item-content-title"
  }, [_vm._v("第 2 步：搜索找到PlexVPN并下载")]), _vm._v(" "), _c('div', {
    staticClass: "dgic-item-content-text"
  }, [_c('p', [_vm._v("在App Store中找到PlexVPN进行下载")]), _vm._v(" "), _c('p', [_vm._v("*注意：")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("请务必认准如图所示官方正版PlexVPN进行下载使用")]), _vm._v(" "), _c('li', [_vm._v("使用公共账号下载完成后，请立即退出账号，否则手机会有被锁的风险")]), _vm._v(" "), _c('li', [_vm._v("\n              若公共账号无法使用，您可以\n              "), _c('router-link', {
    staticClass: "link-color",
    attrs: {
      "to": "/region-tutorial-iOS"
    }
  }, [_vm._v("【修改自己AppleID的所属地区】")]), _vm._v("进行下载\n            ")], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dgic-item"
  }, [_c('img', {
    staticClass: "dgic-item-img",
    attrs: {
      "src": require("../../../static/img/downloadGuideIos/dgi_img_switch.jpg"),
      "alt": "dgi-img-switch"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dgic-item-content"
  }, [_c('h3', {
    staticClass: "dgic-item-content-title"
  }, [_vm._v("第 1 步：切换App Store中的AppleID为公共账号")]), _vm._v(" "), _c('div', {
    staticClass: "dgic-item-content-text"
  }, [_c('p', [_vm._v("打开App Store进行账号切换")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("公共账号：")]), _vm._v(" "), _c('li', [_vm._v("苹果账户: plexv3@hotmail.com 密码: OfficialService1")]), _vm._v(" "), _c('li', [_vm._v("苹果账户: plexv6@outlook.com 密码: OfficialService6")])]), _vm._v(" "), _c('p', [_vm._v("* 注：不要在 “ 个人设置 ” 中切换账号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bf1e0c9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/downloadGuideIos/downloadGuideIos.vue
// module id = 1290
// module chunks = 1